import { isYes } from '../../../../../../../components/loan_application/utils/helpers';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { isOwnPropertyUnderConstruction } = loanFormModel.formField;

class IsOwnPropertyUnderConstruction implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isOwnPropertyUnderConstructionValue =
      application[isOwnPropertyUnderConstruction.name];

    return (
      isOwnPropertyUnderConstructionValue !== null &&
      isOwnPropertyUnderConstructionValue !== undefined &&
      isYes(isOwnPropertyUnderConstructionValue)
    );
  }
}

export default new IsOwnPropertyUnderConstruction();
